import { render, staticRenderFns } from "./TabListSIK.vue?vue&type=template&id=462a9c6a&scoped=true"
import script from "./TabListSIK.vue?vue&type=script&lang=js"
export * from "./TabListSIK.vue?vue&type=script&lang=js"
import style0 from "./TabListSIK.vue?vue&type=style&index=0&id=462a9c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462a9c6a",
  null
  
)

export default component.exports